import React, { Fragment, useState, useCallback } from 'react';
import { validation } from 'site-modules/shared/components/form-validation/validation';
import { LP_ERROR_KEYS } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/constants/license-plate-constants';

export const ERROR_MESSAGE_MAP = {
  licensePlate: {
    INVALID: 'Please enter a valid license plate',
    LANDING_INVALID: vinTabLink => (
      <Fragment>
        We could not find that license plate. If your license plate is a special plate (vanity, disabled person, special
        interest, etc.), please use your {vinTabLink} instead.
      </Fragment>
    ),
    ERROR: "We're sorry, we could not look up your license plate at this time.",
    NO_STYLES: "We're sorry. We were unable to locate your license plate. Please try entering a VIN instead.",
  },
  stateCode: {
    INVALID: 'Please select a state',
  },
};

export function useLicensePlateValidation() {
  const [errorMap, setErrorMap] = useState({});
  const [isLpValid, setIsLpValid] = useState(true);

  const validateFields = useCallback((lpValue, stateCodeValue) => {
    const isValidLicensePlate = validation.validateLicensePlate(lpValue);
    const isValidStateCode = validation.validateValue(stateCodeValue);
    const isValid = isValidLicensePlate && isValidStateCode;

    const updatedErrorMap = {};
    if (!isValidLicensePlate) {
      updatedErrorMap[LP_ERROR_KEYS.LICENSE_PLATE] = ERROR_MESSAGE_MAP.licensePlate.INVALID;
    }
    if (!isValidStateCode) {
      updatedErrorMap[LP_ERROR_KEYS.STATE_CODE] = ERROR_MESSAGE_MAP.stateCode.INVALID;
    }

    setErrorMap(updatedErrorMap);
    setIsLpValid(isValid);

    return { isValid, errorMap: updatedErrorMap };
  }, []);

  const clearFieldError = useCallback(key => {
    setErrorMap(prev => {
      if (!(key in prev)) {
        return prev;
      }
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  }, []);

  const setLpError = useCallback((key, message) => {
    setErrorMap(prev => {
      const updated = { ...prev };
      if (key === LP_ERROR_KEYS.LICENSE_PLATE_WIDE) {
        delete updated[LP_ERROR_KEYS.LICENSE_PLATE];
      } else if (key === LP_ERROR_KEYS.LICENSE_PLATE) {
        delete updated[LP_ERROR_KEYS.LICENSE_PLATE_WIDE];
      }
      updated[key] = message;
      return updated;
    });
    setIsLpValid(false);
  }, []);

  const isStateValid = !(LP_ERROR_KEYS.STATE_CODE in errorMap);

  return { errorMap, isLpValid, isStateValid, validateFields, clearFieldError, setLpError };
}
